import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Candidates|Summary|Affiliations';
const sharedData: Pick<LocDef, 'feature' | 'type' | 'portal' | 'htmlAllowed' | 'shared'> = {
	feature: HubFeature.CandidateProfilePrimaryInformationAffiliation,
	portal: 'SP',
	htmlAllowed: false,
	shared: false,
};

export type SpCandidateAffiliationLocs = 'SPCandidateAffiliationInstructions' | 'SPCandidateAffiliationCancel';

export const spCandidateAffiliationLocs: LocDefs<SpCandidateAffiliationLocs> = {
	SPCandidateAffiliationInstructions: {
		...sharedData,
		defaultValue:
			'When a field is disabled, it is not allowed for that affiliation. If there is data in a disabled field, it will be deleted when the form is submitted.',
		description: 'Instructions for the affiliation form.',
		displayType: 'Content',
		displayPath: `${dpRoot}|Instructions`,
		legacyName: 'CandidateProfile.PrimaryInformation.Affiliation/Candidates.Affiliations.Content.AffInstructions',
		htmlAllowed: true,
	},
	SPCandidateAffiliationCancel: {
		...sharedData,
		defaultValue: 'Cancel',
		description: 'The cancel button on the form and the cancel icon in the section header.',
		displayType: 'Button',
		displayPath: `${dpRoot}|Cancel`,
		legacyName: 'CandidateProfile.PrimaryInformation.Affiliation/Candidates.Affiliations.Button.Cancel',
	},
};

export const SpCandidateAffLocs = MapLocKeys<SpCandidateAffiliationLocs>(spCandidateAffiliationLocs);
export type SpCandidateAffLocsType = LocMap<SpCandidateAffiliationLocs>;
